import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { CatalogProvider } from './context/CatalogContext';
import { Toaster } from './components/ui/sonner';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Movies from './pages/Movies';
import Shows from './pages/Shows';
import Podcasts from './pages/Podcasts';
import PodcastDetail from './pages/PodcastDetail';
import Live from './pages/Live';
import Originals from './pages/Originals';
import MyList from './pages/MyList';
import SearchPage from './pages/Search';
import Player from './pages/Player';
import { SignIn, SignUp, Forgot } from './pages/Auth';
import Onboarding from './pages/Onboarding';
import Profiles from './pages/Profiles';
import Account from './pages/Account';
import Studio from './pages/Studio';
import Admin from './pages/Admin';

function App() {
  return (
    <CatalogProvider>
    <AppProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/movies" element={<Movies />} />
          <Route path="/shows" element={<Shows />} />
          <Route path="/podcasts" element={<Podcasts />} />
          <Route path="/podcasts/:id" element={<PodcastDetail />} />
          <Route path="/live" element={<Live />} />
          <Route path="/originals" element={<Originals />} />
          <Route path="/my-list" element={<MyList />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/watch/:id" element={<Player />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot" element={<Forgot />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/profiles" element={<Profiles />} />
          <Route path="/account" element={<Account />} />
          <Route path="/studio/*" element={<Studio />} />
          <Route path="/admin/*" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="bottom-right" theme="dark" richColors />
      </BrowserRouter>
    </AppProvider>
    </CatalogProvider>
  );
}

export default App;
